import Utils from './utils.class';
const siteTop = 1; // Trigger on any scrolling

(function ($) {
  const scrollOffset = $("header").height();
  const scrollSpeed = 750;

  $(document).on("scroll",  Utils.debounce(100, true, function () {
    const scrollPos = $(document).scrollTop();
    if (siteTop && scrollPos >= siteTop) {
      $('.site_header').addClass('scrolled');
    } else if (siteTop && scrollPos < siteTop) {
      $('.site_header').removeClass('scrolled');
    }
  }));

  if (location.hash) {
    setTimeout(function () {
      Utils.scrollToHash(location.hash, null, scrollOffset, scrollSpeed);
    }, 300);
  }

  $(window).on('hashchange', function (e) {
    if (location.hash) {
      if (Utils.scrollToHash(location.hash, null, scrollOffset, scrollSpeed)) {
        e.preventDefault();
      }
    }
  });

})(jQuery);
